import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <main className="bg-white min-h-screen flex items-center justify-center py-24">
    <div className="container-page text-center">
      <p className="font-display text-[#FF5A1F] font-bold uppercase tracking-[0.22em] text-sm">
        Erreur 404
      </p>
      <h1 className="mt-4 font-display font-black text-5xl sm:text-7xl text-navy leading-none">
        Page introuvable
      </h1>
      <p className="mt-5 text-muted-foreground max-w-md mx-auto">
        La page que vous cherchez n'existe pas ou a été déplacée.
      </p>
      <Link to="/" className="mt-8 inline-flex btn-primary">
        <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
        Retour à l'accueil
      </Link>
    </div>
  </main>
);

export default NotFoundPage;
